import React, { ReactNode } from 'react';
import styles from './DetailsPanel.module.scss';
import classNames from 'classnames/bind';
import { Typography } from '../Typography/Typography';
import { EditIcon } from '../../assets/icons/EditIcon';
const cx = classNames.bind(styles);

export interface DetailsPanelProps {
  title: string;
  children: ReactNode;
  onEdit?: () => void;
  className?: string;
}

const DetailsPanel = ({ title, onEdit, children, className }: DetailsPanelProps) => {
  return (
    <div className={cx('panel', className)}>
      <Typography size="XL" weight="semi-bold" className={cx('title')}>
        {title}
        {onEdit && (
          <button aria-label="Edit" className={cx('edit-button')} onClick={onEdit}>
            <EditIcon size="small" />
          </button>
        )}
      </Typography>
      {children}
    </div>
  );
};

export default DetailsPanel;
